export const RETRIEVING_DASHBOARD_DETAIL = 'Retrieving Dashboard Detail';
export const RETRIEVING_DASHBOARD_STRUCTURE = 'Retrieving Dashboard Structure';
export const DOWNLOADING_DASHBOARD_RESULTS = 'Downloading Dashboard Results';
